import { Icon } from '../components';

/**
 * In SpendMeter's place when there's no figure to show, so spend never reads as a zero. With
 * `caution` the gap needs a person (calls recorded no cost, so neither limit can act).
 */
export function SpendMissing({
  value,
  detail,
  caution,
  period,
  compact,
}: {
  value: string;
  detail?: string;
  caution?: boolean;
  period?: string;
  compact?: boolean;
}) {
  const icon = caution ? <Icon name="triangle-alert" size={compact ? 12 : 14} /> : null;
  return (
    <div
      className={['rq-spend', 'is-missing', caution && 'is-alert', compact && 'is-compact']
        .filter(Boolean)
        .join(' ')}
      role="group"
      aria-label={`AI spend: ${value}${detail ? `. ${detail}` : ''}`}
    >
      <div className="rq-spend-head">
        <span className="rq-spend-label">AI spend{period && !compact ? `, ${period}` : ''}</span>
        <span className="rq-spend-num rq-missing">
          {compact ? icon : null}
          {value}
        </span>
      </div>
      {detail && !compact ? (
        <div className="rq-spend-foot">
          <span className="rq-spend-state">
            {icon}
            {detail}
          </span>
        </div>
      ) : null}
    </div>
  );
}
